module.exports = __webpack_public_path__ + "static/media/perito_d.e2b78e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/perito_d.png
// module id = 1162
// module chunks = 0